import { memo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
// @mui
import { styled, useTheme } from '@mui/material/styles';
import {
  Box,
  Stack,
  ButtonBase, Paper, Popover,
} from '@mui/material';
// sections
import SearchPopover from '../../@header/SearchPopover';
import AccountPopover from '../../@header/AccountPopover';
import LanguagePopover from '../../@header/LanguagePopover';
import WebsitePopover from '../../@header/WebsitePopover';

// hooks
import { usePathname } from '../../../hooks/usePathname';

// 
import { NavSectionHorizontal } from '../../@header/navbar';
import ToggleMode from '../../@header/ToggleMode';


// 
import { GLOBAL_CATALOGS } from '../../../store/types';

/* ======================================================================================= */

const OverlayStyle = styled(Box)(
  ({ theme }) => `
    position: relative;
    .Sim-menu-header{
      svg {
        transition: all .4s ease
      };
    };
    .Sim-menu-content{
      min-width: 100px;
      padding: 0px;
      position: absolute;
      top: 100%;
      z-index: 10;
      transition: all .3s ease;
      transform: scaleY(1);
      transform-origin: top center;
      opacity: 0;
      visibility: hidden;
      text-align: left;
      border-radius: 4px;
      box-shadow: 0px 6px 8px 0px rgba(0, 0, 0, 0.12);
    };
    
    &:hover{
      .Sim-menu-header{
        &:after {
          width: 100%;
        };
        svg {
          fill: ${theme.palette.action.selected};
          color: ${theme.palette.action.selected};
        };
      };
      .Sim-menu-content{
        transform: scaleY(1);
        opacity: 1;
        visibility: visible;
      }
    }
  `
);
IconPopover.propTypes = {
  children: PropTypes.node,
  primary: PropTypes.node,
  content: PropTypes.node,
  position: PropTypes.object,
};
export function IconPopover({ primary, children, content, position = { x: '0px', y: '0px' } }) {
  const theme = useTheme();
  return (
    <OverlayStyle>
      <ButtonBase
        className={'Sim-menu-header'}
        disableRipple
        sx={{
          height: '100%',
          py: 0,
          px: 1.5,
          borderRadius: 0,
          transition: 'all .4s ease',
          willChange: 'revert',
          ...theme.typography.hoverSecondaryUnderline2px,
        }}
      >
        { primary || children }
      </ButtonBase>
      <Paper className={'Sim-menu-content'} sx={{ left: position.x || 0 }}>
        { content }
      </Paper>
    </OverlayStyle>
  )
}

// ==============================|| Header Horizontal ||============================== //

HeaderHorizontal.propTypes = {
  onOpenNav: PropTypes.func,
  profile: PropTypes.object,
  application: PropTypes.object,
};

function HeaderHorizontal({ profile, existToken, application, navigations = [] }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const dispatch = useDispatch();
  const pathname = usePathname();

  return (
    <>
      <NavSectionHorizontal navConfig={navigations} />

      <Stack
        direction="row"
        alignItems="stretch"
        justifyContent={"stretch"}
        spacing={{ xs: 0, sm: 0 }}
        sx={{ minHeight: '100%' }}
      >

        <SearchPopover />

        {/* <LanguagePopover /> */}

        <WebsitePopover />

        <ToggleMode />

        <AccountPopover existToken={existToken} />

      </Stack>
    </>
  );
}
export default memo(HeaderHorizontal)
